var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProcess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.21.732a.6.6 0 01-.27.805l-3.826 1.914 1.913 3.827a.6.6 0 01-1.073.536l-2.182-4.363a.6.6 0 01.269-.805L17.404.464a.6.6 0 01.805.268z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.822 3.225a.6.6 0 01.663-.53c5.207.579 9.152 4.758 9.152 10.306 0 4.944-3.11 9.116-7.524 10.394a.6.6 0 01-.334-1.153c3.875-1.122 6.658-4.804 6.658-9.241 0-4.926-3.474-8.6-8.085-9.113a.6.6 0 01-.53-.663zM8.678 17.919a.6.6 0 01.805.268l2.181 4.364a.6.6 0 01-.268.805l-4.363 2.182a.6.6 0 11-.537-1.074l3.827-1.913-1.914-3.827a.6.6 0 01.269-.805z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.068 3.015a.6.6 0 01-.41.744C5.784 4.88 3.002 8.563 3.002 13c0 4.926 3.474 8.6 8.084 9.113a.6.6 0 11-.132 1.193C5.745 22.727 1.8 18.548 1.8 13c0-4.944 3.109-9.116 7.524-10.394a.6.6 0 01.743.41z",
    fill: "currentColor"
  })));
}

export default SvgProcess;